<template>
  <span style="margin-left:5px;"><img style="margin:5px 0px;width:190px" :src="logo"></span>
</template>
<script>
import { mapGetters } from 'vuex'
import logoUrl from '@/assets/login_images/logo.png'
import logoUrl1 from '@/assets/login_images/logo1.png'
export default {
  computed: {
    ...mapGetters([
      'sidebar'
    ])
  },
  data() {
    return {
      language: 'zh',
      logo: ''
    }
  },
  created() {
    this.language = this.$store.state.app.language
    if (this.language === 'zh') {
      this.logo = logoUrl
    } else {
      this.logo = logoUrl1
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Logo/index.vue